<template>
  <div class="dialog-upload">
    <div class="modal" :class="{ 'is-active': showDialogUpload }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Upload ảnh</p>
          <button class="delete" @click="onClose" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          <div class="card-body">
            <!-- <div class="file" v-show>
              <label class="file-label">
                
                <span class="file-cta">
                  <span class="file-icon">
                    <img src="/img/icons/upload.svg" width="20" height="20" alt />
                  </span>
                  <span class="file-label">Chọn 1 ảnh...</span>
                </span>
              </label>
            </div> -->
            <input v-show="false" class="file-input" ref="fileInput" type="file" @change="onChangeFile" />

            <div v-if="imgSrc">
              <!-- <b-button @click="rotateCropImg">Xoay ảnh</b-button> -->
              <VueCropper
                v-if="imgType !== 'a'"
                ref="cropper"
                :guides="false"
                :view-mode="1"
                drag-mode="move"
                :auto-crop-area="0.5"
                :minCropBoxWidth="100"
                :minCropBoxHeight="100"
                :min-container-width="250"
                :min-container-height="300"
                :background="true"
                :rotatable="true"
                :initialAspectRatio="6 / 4"
                :img-style="{ 'max-width': '400px', 'max-height': '400px' }"
                :containerStyle="cropperStyles"
                :src="imgSrc"
                alt="Source Image"
              />
              <VueCropper
                v-else
                ref="cropper"
                :guides="true"
                :view-mode="1"
                drag-mode="crop"
                :auto-crop-area="0.5"
                :min-container-width="250"
                :min-container-height="180"
                :minCropBoxWidth="300"
                :minCropBoxHeight="300"
                :background="true"
                :rotatable="true"
                :aspectRatio="1 / 1"
                :img-style="{ 'max-width': '300px', 'max-height': '300px' }"
                :containerStyle="cropperStyles"
                :src="imgSrc"
                alt="Source Image"
              />
            </div>
            <div v-else class="cropper-placeholder" @dragover.prevent @drop.prevent="handleDropImage">
              <div class="choose-an-image">
                <img src="/img/icons/picture.svg" width="88" height="70" alt />
                <br />
                <span>Kéo thả hình ành vào đây hoặc <p @click="handleUploadImg">Chọn ảnh từ máy tính</p></span>
              </div>
            </div>
          </div>
        </section>
        <div class="modal-card-foot">
          <b-button class="button is-warning" :disabled="loading" @click="uploadImage">Đồng ý</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const VueCropper = () => import(/* webpackMode: "lazy" */ "vue-cropperjs");
import UploadImage from "../../mixins/upload-image";
import { mapGetters } from "vuex";

const IMAGE_KEYS = {
  FRONTSIDE: "f",
  BACKSIDE: "b",
  FRONT_FAMILY: "ff",
  BACK_FAMILY: "bf",
  AVATAR: "a",
  OTHER_1: "others_1",
  OTHER_2: "others_2"
};

const FILE_NAME_KEY = {
  FRONT: "id_card_front",
  BACK: "id_card_back",
  FRONT_FAMILY: "family_register_front",
  BACK_FAMILY: "family_register_back",
  OTHER_1: "others_1",
  OTHER_2: "others_2",
  OTHER: "other_image"
};

export default {
  mixins: [UploadImage],
  components: {
    VueCropper
  },
  computed: {
    ...mapGetters(["supplierToken", "supplierProfile"]),
    supplierId () {
      return this.supplierProfile && this.supplierProfile._id
    }
  },
  data() {
    return {
      showDialogUpload: false,
      imgSrc: null,
      cropperStyles: {
        width: "auto",
        "max-height": "300px"
      },
      loading: true,
      imgType: ""
    };
  },
  methods: {
    onClose() {
      this.showDialogUpload = false;
      this.imgSrc = null;
      this.$refs.fileInput.value = null;
    },
    handleUploadImg() {
      this.$refs.fileInput.click();
    }, 
    onChangeFile($event) {
      const file = $event.target.files[0];
      if (!file) return;
      this.loading = false;
      this.$_uploadImage_readImage(file).then(baseFile => {
        this.imgSrc = baseFile;
        if (this.$refs.cropper) this.$refs.cropper.replace(baseFile);
      });
    },
    handleDropImage(e) {
      console.log('handleDropImage', e);
      const dropFiles = e.dataTransfer.files;
      if (dropFiles && dropFiles[0]) {
        this.setImageCrop(dropFiles[0], true)
      }
    },
    setImageCrop(data, isSingleFile = false) {
      let file
      if (isSingleFile) file = data
      else file = data.target.files[0];
      if (!file) return;

      this.$_uploadImage_readImage(file).then(baseFile => {
        this.imgSrc = baseFile;
        this.loading = false;
        if (this.$refs.cropper) this.$refs.cropper.replace(baseFile);
      });

      if (!isSingleFile) data.target.value = "";
    },
    rotateCropImg() {
      this.$refs.cropper.rotate(90);
    },
    cancelUpload() {
      this.imgSrc = null;
      this.onClose();
    },
    uploadImage() {
      const supplierId = this.supplierId
      this.loading = true;
      const image = this.$refs.cropper.getCroppedCanvas().toDataURL();
      if (!image) return;
      this.$emit('changeUploadingImg', this.imgType, image)
      const imgKey = "image/jpeg";
      this.$refs.cropper.getCroppedCanvas().toBlob(blob => {
        // NOTE: toBlob() is not supported in IE, use a polyfill for IE.

        if (!blob) {
          return;
        }

        if (this.imgType !== IMAGE_KEYS.AVATAR) {
          let fileID = "";
          switch (this.imgType) {
            // IDENTIFICATION CARD
            case IMAGE_KEYS.FRONTSIDE:
              fileID = `${FILE_NAME_KEY.FRONT}_${supplierId}`;
              break;
            case IMAGE_KEYS.BACKSIDE:
              fileID = `${FILE_NAME_KEY.BACK}_${supplierId}`;
              break;
            //REGISTER BOOK
            case IMAGE_KEYS.FRONT_FAMILY:
              fileID = `${FILE_NAME_KEY.FRONT_FAMILY}_${supplierId}`;
              break;
            case IMAGE_KEYS.BACK_FAMILY:
              fileID = `${FILE_NAME_KEY.BACK_FAMILY}_${supplierId}`;
              break;
            // ANOTHER
            case IMAGE_KEYS.OTHER_1:
              fileID = `${FILE_NAME_KEY.OTHER_1}_${supplierId}`;
              break;
            case IMAGE_KEYS.OTHER_2:
              fileID = `${FILE_NAME_KEY.OTHER_2}_${supplierId}`;
              break;
            default:
              fileID = `${FILE_NAME_KEY.OTHER}_${supplierId}`;
          }

          blob.file_id = fileID;
          var file = new File([blob], `${fileID}.jpg`, {type: "application/octet-stream"});
          file.file_id = fileID;
          /* NOTE: File is not supported in IE/EDGE/OperaForAndroid, 
          More detail: https://developer.mozilla.org/en-US/docs/Web/API/File/File. */

          this.$store.dispatch("uploadImageID", file).then(response => {
            if (response.location) {
              this.$emit("addImage", this.imgType, response.location);
              this.loading = false;
              this.showDialogUpload = false;
              this.$refs.fileInput.value = null;
            }
          }).catch(() => {
            this.imgSrc = null;
            this.$buefy.notification.open({
              message: this.$t("driver_onboarding.attach_file.message.invalid_size"),
              type: "is-danger",
              duration: 3000,
              position: "is-bottom"
            });
          });
        } else {
          blob.supplier_id = this.supplierId;
          blob.supplier_token = this.supplierToken;
          this.$store
            .dispatch("uploadAvatar", blob)
            .then(() => {
              this.showDialogUpload = false;
              this.loading = false;
              this.$refs.fileInput.value = null;
              this.$emit("onChangeAvatar");
            })
            .catch(error => {
              if(error.status === 404) {
                this.$buefy.notification.open({
                  message: this.$t("driver_onboarding.auth.token_expire"),
                  type: "is-danger",
                  duration: 3000,
                  position: "is-bottom"
                });
                this.$router.push({ name: "signin" });
              }else{
                this.$buefy.notification.open({
                  message: `Lỗi ${error.response.status}: ${error.response.data.description}`,
                  type: "is-danger",
                  duration: 3000,
                  position: "is-bottom"
                });
              }
            });
        }
      }, imgKey);
    }
  },
  mounted() {
    this.$refs.fileInput.value = "";
    this.imgSrc = null;
  }
};
</script>
<style lang="scss" scoped>
.dialog-upload {
  .cropper-placeholder {
    width: 100%;
    height: 300px;
    background-color: #f7f7f7;
    position: relative;

    .choose-an-image{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      span{
        font-weight: 500;
        p{
          color: #ff8200;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
   
  }

  .modal {
    .modal-card {
      p.modal-card-title {
        margin: 0;
      }
      .modal-card-body {
        // border: 1px dashed #bcbcbc;
        // border-radius: 4px;
        height: inherit;
        .card-body{
          border: 1px dashed #bcbcbc;
          border-radius: 4px;
          padding: 10px;
          height: inherit;
          
          input {
            margin-bottom: 10px;
          }
          .file {
            margin-bottom: 20px;
          }
        }
        
      }
      .modal-card-foot {
        button {
          background-color: #ff8200;
          color: #fff;
          width: 100px;
          float: right;
        }
      }
    }
  }
}
</style>
